import vue from 'vue'

vue.component('o-card', () => import('@/components/ui/OCard.vue'))
vue.component('o-button', () => import('@/components/ui/OButton.vue'))
vue.component('tooltip', () => import('@/components/ui/Tooltip.vue'))
